var FontSizeData_fontType = /* @__PURE__ */ ((FontSizeData_fontType2) => {
  FontSizeData_fontType2["PX"] = "PX";
  FontSizeData_fontType2["EM"] = "EM";
  FontSizeData_fontType2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return FontSizeData_fontType2;
})(FontSizeData_fontType || {});
export {
  FontSizeData_fontType
};
//# sourceMappingURL=decoration_fontsize.enums.js.map
